module.exports = __webpack_public_path__ + "img/oiltour_lvxie_logo.557200ff.png";